import { render, staticRenderFns } from "./SinglePageIcon.vue?vue&type=template&id=3bccab28"
import script from "./SinglePageIcon.vue?vue&type=script&lang=ts"
export * from "./SinglePageIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports